import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components";
import { useBeevisionAuditLogs } from "../../store/useBeevisionAuditLogs";
import { useMarketPricing } from "../../store/useMarketPricing";
import { Tooltip } from "@material-tailwind/react";
import InformationIcon from "../../assets/icons/info/information.png";
import dayjs from "dayjs";
import { useEffect } from "react";

export function BeevisionAuditLogsTable() {
  const navigate = useNavigate();
  const { logs } = useBeevisionAuditLogs();
  const { marketPrices, getAllMarketPrices } = useMarketPricing();

  useEffect(() => {
    getAllMarketPrices();
  }, [getAllMarketPrices]);

  const getMarketPriceName = (marketPriceId: string) => {
    const marketPrice = marketPrices.find((mp) => mp._id === marketPriceId);
    return marketPrice?.name || "N/A";
  };

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Name
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Status
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Final Accepted Material
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              AI Processed Result
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Drop Weight
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Created At
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr
              key={log._id}
              className="bg-white border-b cursor-pointer hover:bg-gray-50"
            >
              <th
                onClick={() => navigate(`/beevision-audit-logs/${log._id}`)}
                scope="row"
                className="px-2 sm:px-6 py-1 sm:py-4 text-xs sm:text-base font-bold text-primary-base whitespace-nowrap"
              >
                {log.user?.first_name || "N/A"} {log.user?.last_name || ""}
              </th>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                <span
                  className={`font-bold ${
                    log.status === "approved"
                      ? "text-green-500"
                      : log.status === "rejected" ||
                          log.status === "webhook_rejected"
                        ? "text-red-500"
                        : log.status === "pending"
                          ? "text-orange-500"
                          : "text-gray-800"
                  }`}
                >
                  {log.status.charAt(0).toUpperCase() + log.status.slice(1)}
                </span>
                {(log.status === "rejected" ||
                  log.status === "webhook_rejected") &&
                  log.rejectionReason && (
                    <Tooltip
                      content={log.rejectionReason}
                      placeholder={undefined}
                    >
                      <img
                        src={InformationIcon}
                        alt="info"
                        className="inline-block w-4 h-4 ml-1 cursor-pointer"
                      />
                    </Tooltip>
                  )}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {/* @ts-ignore */}
                {getMarketPriceName(log?.dropData?.marketPrice)}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {/* @ts-ignore */}
                {log?.beevisionDrop?.marketPrice?.name || "N/A"}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {log?.dropData?.weight
                  ? new Intl.NumberFormat("nl-NL", {
                      style: "unit",
                      unit: "kilogram",
                      unitDisplay: "short",
                    }).format(Number(log.dropData.weight))
                  : "N/A"}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                {dayjs(log.createdAt).format("DD/MM/YY HH:mm")}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                <PrimaryButton
                  label="View"
                  onClick={() => navigate(`/beevision-audit-logs/${log._id}`)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
